import React from 'react';
import './Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3 className="footer-logo">
              <span className="logo-icon">💼</span>
              Freelancher
            </h3>
            <p className="footer-description">
              Η κορυφαία πλατφόρμα για Έλληνες IT Freelancers.
              Συνδέουμε επαγγελματίες με έργα που αξίζουν.
            </p>
          </div>

          <div className="footer-section">
            <h4>Υπηρεσίες</h4>
            <ul>
              <li><a href="#web-dev">Web Development</a></li>
              <li><a href="#mobile-dev">Mobile Development</a></li>
              <li><a href="#design">UI/UX Design</a></li>
              <li><a href="#backend">Backend Development</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Εταιρεία</h4>
            <ul>
              <li><a href="#about">Σχετικά με εμάς</a></li>
              <li><a href="#careers">Καριέρα</a></li>
              <li><a href="#blog">Blog</a></li>
              <li><a href="#contact">Επικοινωνία</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Επικοινωνία</h4>
            <ul>
              <li>📧 info@freelancher.gr</li>
              <li>📞 +30 210 123 4567</li>
              <li>📍 Αθήνα, Ελλάδα</li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} Freelancher. Με επιφύλαξη παντός δικαιώματος.</p>
          <div className="footer-links">
            <a href="#privacy">Πολιτική Απορρήτου</a>
            <a href="#terms">Όροι Χρήσης</a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
